angular.module('unergie.main')
.controller('supervisionCtrl', ($scope, $state, $interval, Healthchecks, DataAccess, BoFeaturesService, EventProcessorService, SocketFactory, ErrorCatcher) => {
    const terminationSounds = [
        new Audio('/sounds/aww.mp3'),
        new Audio('/sounds/albatar1.mp3'),
        new Audio('/sounds/albatar2.mp3'),
        new Audio('/sounds/albatar3.mp3'),
        new Audio('/sounds/albatar4.mp3'),
    ]

    let subscriptionSound
    $scope.isPlum = BoFeaturesService.get('provider') === 'plum'
    if ($scope.isPlum) {
        subscriptionSound = new Audio('/sounds/oh-yeah.mp3')
    } else {
        subscriptionSound = new Audio('/sounds/cha-ching.mp3')
    }

    const subscriptionSmallBusinessSound = new Audio('/sounds/yehaw.mp3')
    const subscriptionProSound = new Audio('/sounds/ole.mp3')

    $scope.playTerminationSound = () => {
        terminationSounds[Math.floor(Math.random() * terminationSounds.length)].play()
    }

    SocketFactory.join('SUPERVISION', $scope)
    EventProcessorService.register('NEW_CONTRACT_SIGNED', 'ALL', $scope, () => subscriptionSound.play())
    EventProcessorService.register('NEW_CONTRACT_SIGNED_SMALL_BUSINESS', 'ALL', $scope, () => subscriptionSmallBusinessSound.play())
    EventProcessorService.register('NEW_CONTRACT_SIGNED_PRO', 'ALL', $scope, () => subscriptionProSound.play())
    EventProcessorService.register('CONTRACT_TERMINATED', 'ALL', $scope, $scope.playTerminationSound)

    const STATUS = {
        CREATING_CONTRACT: -1,
        INITIAL: 0,
        REQUESTED: 1,
        ACTIVE: 2,
        TERMINATED: 4,
        CUT_LIMITED: 5,
        OTHER: 6,
        GRD_ACTIVATION_ERROR: 9,
        WAITING_TIMETABLE: 80,
        WAITING_SWITCH_READING: 81,
        MANUAL_MES_INTER: 82,
        FIRST_MES_INTER: 83,
        WARNING_DUPLICATE: 84,
        RETRACTED: 90,
        CANCELLED: 91,
        ON_HOLD: 92,
    }

    $scope.isActive = (state) => $state.is(state)

    $scope.displayField = BoFeaturesService.fieldTester('supervision')

    gapi.analytics.ready(() => {
    // auth
        gapi.analytics.auth.authorize({
            container: 'supervision-auth',
            clientid: '962493129254-35851bmiso0rpkhfs0a1irfob3jtv2tq.apps.googleusercontent.com',
        })
        // active users
        const activeUsers = new (gapi.analytics.ext.ActiveUsers)({
            container: 'supervision-activeusers',
            pollingInterval: 5,
            ids: 'ga:123021404' })
        activeUsers.once('success', function () {
            let element = this.container.firstChild
            let timeout
            this.on('change', function (data) {
                // `var element`
                element = this.container.firstChild
                const animationClass = data.delta > 0 ? 'is-increasing' : 'is-decreasing'
                element.className += ` ${animationClass}`
                clearTimeout(timeout)
                timeout = setTimeout((() => {
                    element.className = element.className.replace(RegExp(' is-(increasing|decreasing)', 'g'), '')
                }), 3000)
            })
        })

        /**
     * Extend the Embed APIs `gapi.analytics.report.Data` component to
     * return a promise the is fulfilled with the value returned by the API.
     * @param {Object} params The request parameters.
     * @return {Promise} A promise.
     */

        const query = (params) =>
            new Promise((resolve, reject) => {
                const data = new (gapi.analytics.report.Data)({ query: params })
                data.once('success', (response) => {
                    resolve(response)
                }).once('error', (response) => {
                    reject(response)
                }).execute()
            })


        /**
     * Create a new canvas inside the specified element. Set it to be the width
     * and height of its container.
     * @param {string} id The id attribute of the element to host the canvas.
     * @return {RenderingContext} The 2D canvas context.
     */

        const makeCanvas = function (id) {
            const container = document.getElementById(id)
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            container.innerHTML = ''
            canvas.width = container.offsetWidth
            canvas.height = container.offsetHeight
            container.appendChild(canvas)
            return ctx
        }

        /**
     * Create a visual legend inside the specified element based off of a
     * Chart.js dataset.
     * @param {string} id The id attribute of the element to host the legend.
     * @param {Array.<Object>} items A list of labels and colors for the legend.
     */

        const generateLegend = function (id, items) {
            const legend = document.getElementById(id)
            legend.innerHTML = items.map((item) => {
                const color = item.color || item.fillColor
                const { label } = item
                return `<li><i style="background:${color}"></i>${label}</li>`
            }).join('')
        }

        const renderWeekOverWeekChart = function (ids) {
            // Adjust `now` to experiment with different days, for testing only...
            const now = moment()
            // .subtract(3, 'day');
            const thisWeek = query({
                'ids': ids,
                'dimensions': 'ga:date,ga:nthDay',
                'metrics': 'ga:users',
                'start-date': moment(now).subtract(7, 'day').format('YYYY-MM-DD'),
                'end-date': moment(now).format('YYYY-MM-DD') })
            const lastWeek = query({
                'ids': ids,
                'dimensions': 'ga:date,ga:nthDay',
                'metrics': 'ga:users',
                'start-date': moment(now).subtract(1, 'day').subtract(7, 'day').subtract(1, 'week').format('YYYY-MM-DD'),
                'end-date': moment(now).subtract(1, 'day').subtract(1, 'week').format('YYYY-MM-DD') })
            Promise.all([
                thisWeek,
                lastWeek,
            ]).then((results) => {
                const data1 = results[0].rows.map((row) => +row[2])
                const data2 = results[1].rows.map((row) => +row[2])
                let labels = results[1].rows.map((row) => +row[0])
                labels = labels.map((label) => moment(label, 'YYYYMMDD').format('ddd'))
                const data = {
                    labels,
                    datasets: [
                        {
                            label: 'Last Week',
                            fillColor: 'rgba(220,220,220,0.5)',
                            strokeColor: 'rgba(220,220,220,1)',
                            pointColor: 'rgba(220,220,220,1)',
                            pointStrokeColor: '#fff',
                            data: data2,
                        },
                        {
                            label: 'This Week',
                            fillColor: 'rgba(151,187,205,0.5)',
                            strokeColor: 'rgba(151,187,205,1)',
                            pointColor: 'rgba(151,187,205,1)',
                            pointStrokeColor: '#fff',
                            data: data1,
                        },
                    ],
                }
                new Chart(makeCanvas('supervision-weekvsweek')).Line(data)
                generateLegend('legend-1-container', data.datasets)
            })
        }

        const renderUsersChart = function (ids) {
            // Adjust `now` to experiment with different days, for testing only...
            const now = moment()
            // .subtract(3, 'day');
            const usersToday = query({
                'ids': ids,
                'dimensions': 'ga:hour,ga:nthHour',
                'metrics': 'ga:users',
                'start-date': moment(now).format('YYYY-MM-DD'),
                'end-date': moment(now).format('YYYY-MM-DD') })
            const users7daysAgo = query({
                'ids': ids,
                'dimensions': 'ga:hour,ga:nthHour',
                'metrics': 'ga:users',
                'start-date': moment(now).subtract(7, 'day').format('YYYY-MM-DD'),
                'end-date': moment(now).subtract(7, 'day').format('YYYY-MM-DD') })
            Promise.all([
                usersToday,
                users7daysAgo,
            ]).then((results) => {
                const data1 = results[0].rows.map((row) => +row[2])
                const data2 = results[1].rows.map((row) => +row[2])
                const labels = results[0].rows.map((row) => +row[0])
                const data = {
                    labels,
                    datasets: [
                        {
                            label: 'Users 7 days ago',
                            fillColor: 'rgba(220,220,220,0.5)',
                            strokeColor: 'rgba(220,220,220,1)',
                            pointColor: 'rgba(220,220,220,1)',
                            pointStrokeColor: '#fff',
                            data: data2,
                        },
                        {
                            label: 'Users today',
                            fillColor: 'rgba(151,187,205,0.5)',
                            strokeColor: 'rgba(151,187,205,1)',
                            pointColor: 'rgba(151,187,205,1)',
                            pointStrokeColor: '#fff',
                            data: data1,
                        },
                    ],
                }
                new Chart(makeCanvas('supervision-users')).Line(data)
                generateLegend('legend-users', data.datasets)
            })
        }

        const renderTopBrowsersChart = function (ids) {
            query({
                'ids': ids,
                'dimensions': 'ga:browser',
                'metrics': 'ga:pageviews',
                'sort': '-ga:pageviews',
                'max-results': 5 }).then((response) => {
                    const data = []
                    const colors = [
                        '#4D5360',
                        '#949FB1',
                        '#D4CCC5',
                        '#E2EAE9',
                        '#F7464A',
                    ]
                    response.rows.forEach((row, i) => {
                        data.push({
                            value: +row[1],
                            color: colors[i],
                            label: row[0] })
                    })
                    new Chart(makeCanvas('supervision-browsers')).Doughnut(data)
                    generateLegend('legend-3-container', data)
                })
        }

        // when logged in
        gapi.analytics.auth.on('success', (response) => {
            // hide the auth-button
            document.querySelector('#supervision-auth').style.display = 'none'
            // print analytics
            // dataChart.execute()
            activeUsers.execute()
            const ids = 'ga:123021404'
            renderWeekOverWeekChart(ids)
            renderTopBrowsersChart(ids)
            renderUsersChart(ids)
            // refresh week over week every hour
            setInterval(() => renderWeekOverWeekChart(ids)
                , 60 * 60 * 1000)
            // refresh users and browsers every 10min
            setInterval(() => {
                renderUsersChart(ids)
                return renderTopBrowsersChart(ids)
            }
                , 10 * 60 * 1000)
        })
    })

    // healthchecks
    $scope.healthchecks = undefined
    const refreshHc = function () {
        return Healthchecks.getHCs().$promise.then((healthchecks) => {
            $scope.healthchecks = healthchecks
        }).catch(ErrorCatcher)
    }

    refreshHc()
    const hcLooper = $interval(refreshHc, 60000)

    const countBy = function (contractsElec) { if (contractsElec == null) { contractsElec = {} } return (...statuses) => _.flow(
        _.partial(_.map, _, (status) => _.get(contractsElec, status, 0)),
        _.sum
    )(statuses) }

    const countExceptBy = function (contractsElec) { if (contractsElec == null) { contractsElec = {} } return (...exceptStatuses) => _.flow(
        _.partial(_.map, _, (count, status) => { if (exceptStatuses.indexOf(parseInt(status)) === -1) { return count } return 0 }),
        _.sum
    )(contractsElec) }

    $scope.countContractBy = () => 0
    $scope.countContractExceptBy = () => 0
    $scope.countContractOlderThan2DayBy = () => 0

    // contractsElec
    $scope.contractsElec = undefined
    const refreshContracts = () =>
        DataAccess.supervisionContracts().$promise.then((contractsElec) => {
            $scope.contractsElec = contractsElec
            $scope.countContractBy = countBy(_.get(contractsElec, 'count'))
            $scope.countContractExceptBy = countExceptBy(_.get(contractsElec, 'count'))
            $scope.countContractOlderThan2DayBy = countBy(_.get(contractsElec, 'countOlderThan2Days')) }).catch(ErrorCatcher)

    refreshContracts()
    const contractLooper = $interval(refreshContracts, 60000)

    // odoo
    $scope.odoo = {}
    let odooSyncLooper

    const computeClass = (value, lastValue) => {
        if (value === 0) {
            return 'green'
        }
        if (!lastValue) {
            return 'orange'
        }
        return value >= lastValue ? 'warning' : 'orange'
    }

    const refreshOdooSync = () =>
        DataAccess.supervisionOdoo().$promise.then((odooDataResult) => {
            const odooData = odooDataResult.toJSON()
            odooData.paymentsClass = computeClass(odooData.payments, $scope.odoo.payments)
            odooData.invoicesClass = computeClass(odooData.invoices, $scope.odoo.invoices)
            odooData.invoicesB2gClass = computeClass(odooData.invoicesB2g, $scope.odoo.invoicesB2g)
            $scope.odoo = odooData
        }).catch(ErrorCatcher)

    if ($scope.isPlum) {
        refreshOdooSync()
        odooSyncLooper = $interval(refreshOdooSync, 600000)
    }


    $scope.signedContract = (contractsElec) =>
        countExceptBy(contractsElec)(
            STATUS.CREATING_CONTRACT,
            STATUS.TERMINATED,
            STATUS.WARNING_DUPLICATE,
            STATUS.RETRACTED,
            STATUS.CANCELLED,
            STATUS.ON_HOLD
        )


    $scope.activeContract = () =>
        $scope.countContractBy(
            STATUS.ACTIVE,
            STATUS.INITIAL,
            STATUS.REQUESTED
        )


    $scope.inServiceContract = () => $scope.countContractBy(STATUS.ACTIVE)

    $scope.waitingRetractation = () => $scope.countContractBy(STATUS.INITIAL)

    $scope.waitingPlumAction = () =>
        $scope.countContractBy(
            STATUS.GRD_ACTIVATION_ERROR,
            STATUS.WAITING_TIMETABLE,
            STATUS.MANUAL_MES_INTER,
            STATUS.FIRST_MES_INTER
        )


    $scope.waitingClientAction = () => $scope.countContractBy(STATUS.WAITING_SWITCH_READING)

    $scope.waitingC01C15 = () => $scope.countContractBy(STATUS.REQUESTED)

    $scope.requestedOlderThan2Day = () => $scope.countContractOlderThan2DayBy(STATUS.REQUESTED)

    $scope.$on('$destroy', () => {
        console.log('Cancelling loopers')
        $interval.cancel(hcLooper)
        $interval.cancel(contractLooper)
        $interval.cancel(odooSyncLooper)
    })

    $scope.timeAgo = function (date) {
        if (!date) {
            return
        }
        const time = Date.parse(date)
        let difference = new Date() - time
        // Seconds (e.g. 32s)
        difference /= 1000
        if (difference < 60) {
            return `${Math.floor(difference)} s`
        }
        const seconds = __mod__(Math.floor(difference), 60)
        // Minutes (e.g. 12m)
        difference /= 60
        if (difference < 60) {
            return `${Math.floor(difference)} min ${seconds} s `
        }
        const minutes = __mod__(Math.floor(difference), 60)
        // Hours (e.g. 5h)
        difference /= 60
        if (difference < 24) {
            return `${Math.floor(difference)} h ${minutes} min`
        }
        const hours = __mod__(Math.floor(difference), 24)
        // days
        const days = Math.floor(difference / 24)
        if (days > 1) {
            return `${days} days ${hours} h`
        }
        return `${days} day ${hours} h`
    }

    $scope.timeSinceLastSubscription = function () {
        if ($scope.contractsElec) {
            return $scope.timeAgo($scope.contractsElec.lastSubscription)
        }
    }

    $scope.timeSinceLastActivation = function () {
        if ($scope.contractsElec) {
            return $scope.timeAgo($scope.contractsElec.lastActivation)
        }
    }
})

function __mod__(a, b) {
    a = +a
    b = +b
    return ((a % b) + b) % b
}
